var basicUrl = 'http://47.106.127.93:91'

// 答题卡制作页地址
 export const sheetUrl = process.env.NODE_ENV === 'local' ? 'http://localhost:8081' : process.env.NODE_ENV === 'development' ? 'http://10.10.11.250:725' : process.env.NODE_ENV === 'production' ? 'http://47.106.100.126:81' : ''
// //
export default basicUrl
